import type { GameCategory } from '@repo-level/core-front';
import { useMemo } from 'react';
import { useCollections } from './useCollections';

export const useThemes = () => {
  const { collections } = useCollections();

  const themes = useMemo(() => {
    if (!collections) return new Map();

    const result = new Map<string, GameCategory>();
    collections.forEach((category) => {
      if (category.id.startsWith('@')) {
        result.set(category.id, category);
      }
    });
    return result;
  }, [collections]);

  return { themes };
};
